import UiDuniaBaseFieldset from '@/forms/components/ui-dunia/base-fieldset';
import UiWrapper from '@/forms/components/base/ui-wrapper';
import FieldsetModel from '@/lib/components/models/fieldset';
import formComponentMixin from '@/lib/mixins/form-component-mixin';

import FIELDSET_NAMES from '@/forms/constants/fieldset-names';
import FIELD_NAMES from '@/forms/constants/field-names';

const sharedComponentMixin = {
  data: () => ({
    FIELDSET_NAMES,
    FIELD_NAMES,
  }),

  components: {
    FieldsetModel,
    UiWrapper,
  },

  computed: {
    ...formComponentMixin.computed,
    uiBaseFieldset() {
      return UiDuniaBaseFieldset;
    },
  },

  methods: {
    ...formComponentMixin.methods,
  },

};

export default sharedComponentMixin;
